// https://www.ihospitalapp.com/IHospital-Api2/swagger/index.html
// https://www.ihospitalapp.com/IHospital-ApiTesting/swagger/index.html
// https://beta.ihospitalapp.com/api/swagger/index.html

// LIVE : https://www.ihospitalapp.com/IHospital-Api2/api/
// TEST : https://beta.ihospitalapp.com/api/api/


let baseLiveUrl: string = "https://www.ihospitalapp.com";
let baseTestingUrl: string = "https://beta.ihospitalapp.com"; 

let isLife : boolean = true

export const environment = {
  production: true,
  baseUrl: "https://www.ihospitalapp.com/IHospital-Api2/api/",
  appName: "IHospital",
  imageBaseUrl: "https://www.ihospitalapp.com/IHospital-Api2/api/File/get/",
  imageBaseUrl2: "https://www.ihospitalapp.com/IHospital-Api2/api/File/get2/",
  publishedUrl: baseTestingUrl,
  isLife: isLife,
  firebase: {
    apiKey: 'AIzaSyByGefpW2cKUQotHB1tLFmbe14e3KTbCsI',
    authDomain: 'ihospital-cb494.firebaseapp.com',
    databaseURL: 'https://ihospital-cb494.firebaseio.com',
    projectId: 'ihospital-cb494',
    storageBucket: 'ihospital-cb494.appspot.com',
    messagingSenderId: '280302103170',
    appId: '1:280302103170:web:4607e46f9de1df19e2229b',
    measurementId: 'G-6GM91FB3GD'
  }
};
// ng build --base-href --configuration production >>>> LIVE
// ng build --base-href /iHospitalWebTesting/ --configuration production >>>> TEST

// Note : To Switch From/To Prod/Testing Change  : (envLinks , paymentFormLinks , booking link to paymentForm , paymentStatusAndRate , pay in visit details and list ,<meta name="robots" content="noindex" in index.html>)
// <meta name="robots" content="noindex, nofollow">

// To Create SSR Build follow these Steps :
// first run  >> npm run build:ssr
// then create folder(root folder) then cut the dist folder to the root folder
// then copy all of dist/server content to the root folder
// then create config.web file and fill it with >>>> :

// <?xml version="1.0" encoding="utf-8"?>
// <configuration>
//     <system.webServer>
//         <handlers>
//             <add name="iisnode" path="main.js" verb="*" modules="iisnode" />
//         </handlers>
//         <rewrite>
//             <rules>
//                 <rule name="DynamicContent">
//                     <match url="/*" />
//                     <action type="Rewrite" url="main.js" />
//                 </rule>
//                 <rule name="StaticContent" stopProcessing="true">
//                     <match url="([\S]+[.](jpg|jpeg|gif|css|png|js|ts|cscc|less|ico|html|map|svg))" />
//                     <action type="None" />
//                 </rule>
//             </rules>
//         </rewrite>
//         <staticContent>
//             <clientCache cacheControlMode="UseMaxAge" />
//             <remove fileExtension=".svg" />
//             <remove fileExtension=".eot" />
//             <remove fileExtension=".ttf" />
//             <remove fileExtension=".woff" />
//             <remove fileExtension=".woff2" />
//             <remove fileExtension=".otf" />
//             <mimeMap fileExtension=".ttf" mimeType="application/octet-stream" />
//             <mimeMap fileExtension=".svg" mimeType="image/svg+xml" />
//             <mimeMap fileExtension=".eot" mimeType="application/vnd.ms-fontobject" />
//             <mimeMap fileExtension=".woff" mimeType="application/x-woff" />
//             <mimeMap fileExtension=".woff2" mimeType="application/x-woff" />
//             <mimeMap fileExtension=".otf" mimeType="application/otf" />
//         </staticContent>
//     </system.webServer>
// </configuration>






// <?xml version="1.0" encoding="utf-8"?>
// <configuration>
//     <system.webServer>
//         <rewrite>
//             <rules>
//                 <rule name="Angular Routes" stopProcessing="true">
//                     <match url=".*" />
//                     <conditions logicalGrouping="MatchAll">
//                         <add input="{REQUEST_FILENAME}" matchType="IsFile" negate="true" />
//                         <add input="{REQUEST_FILENAME}" matchType="IsDirectory" negate="true" />
//                     </conditions>
//                     <action type="Rewrite" url="/index.html" />
//                 </rule>
//             </rules>
//         </rewrite>
//     </system.webServer>
// </configuration>
